import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { NGXLogger } from 'ngx-logger';
import { InterventiService } from '../../../services/interventi.service';
import { Liquidazione } from '../../../models/liquidazione.model';
import { TipoRendicontazione } from '../../../models/tipo-rendicontazione.model';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import { Intervento } from '../../../models/intervento.model';

@Component({
  selector: 'app-storico-liquidazioni',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    LottieComponent
  ],
  templateUrl: './storico-liquidazioni.component.html',
  styleUrls: ['./storico-liquidazioni.component.css']
})
export class StoricoLiquidazioniComponent implements OnInit, OnChanges {
  @Input() interventoId!: number;
  @Input() intervento: Intervento | null = null;
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  liquidazioni: Liquidazione[] = [];
  isLoading: boolean = false;

  lottieConfig: AnimationOptions = {
    path: 'assets/animations/spinner-storico-richiesta.json',
    autoplay: true,
    loop: true,
    renderer: 'svg'
  };

  constructor(
    private logger: NGXLogger,
    private interventiService: InterventiService
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['interventoId'] && this.visible && this.interventoId) {
      this.caricaLiquidazioni();
    }
  }

  show(intervento: Intervento) {
    if (!intervento || !intervento.id) {
      return;
    }
    this.intervento = intervento;
    this.interventoId = intervento.id;
    this.visible = true;
    this.visibleChange.emit(true);
    this.caricaLiquidazioni();
  }

  hide() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  getTotaleLiquidato(): number {
    return this.liquidazioni.reduce((acc, l) => acc + (l.importo ?? 0), 0);
  }

  getTipoRendicontazioneBadgeClasses(
    tipo: TipoRendicontazione | null | undefined,
  ): Record<string, boolean> {
    const d = tipo?.descrizione?.toUpperCase?.()?.trim() ?? '';
    return {
      'badge-acconto': d === 'ACCONTO',
      'badge-saldo': d === 'SALDO',
      'badge-tipo-altro': d.length > 0 && d !== 'ACCONTO' && d !== 'SALDO',
    };
  }

  private caricaLiquidazioni(): void {
    if (!this.interventoId) {
      return;
    }
    this.isLoading = true;
    this.interventiService.getStoricoLiquidazioni(this.interventoId).subscribe({
      next: (liquidazioni: Liquidazione[]) => {
        this.liquidazioni = liquidazioni;
        this.isLoading = false;
      },
      error: (error) => {
        this.logger.error('[STORICO LIQUIDAZIONI] Errore nel caricamento delle liquidazioni', error);
        this.isLoading = false;
      }
    });
  }
}

